import Tab from '@material-ui/core/Tab'

export default Tab
